import { defineRoutes } from '../utils';

/**
 * Bilateral Account routes.
 *
 * Phase-2 replacement surface for the parked `/wallet` page —
 * `/accounts` lists every counterparty the viewer has a bilateral
 * balance with. A future `/accounts/:id` page would deep-link to
 * a single Account; for now the `AccountDrawer` opens stack-style
 * from the list, so this single entry is enough.
 */
export const accountsRoutes = defineRoutes({
  accounts: {
    path: '/accounts',
    isPublic: false,
    params: {} as {
      /** Pre-open an Account drawer by id. */
      accountId?: string;
    },
  },
});
